import { render, staticRenderFns } from "./knowPdv.vue?vue&type=template&id=47a6f130&scoped=true"
import script from "./knowPdv.vue?vue&type=script&lang=js"
export * from "./knowPdv.vue?vue&type=script&lang=js"
import style0 from "./knowPdv.vue?vue&type=style&index=0&id=47a6f130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6f130",
  null
  
)

export default component.exports